var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"hidden",attrs:{"id":"input","disabled":_vm.uploading,"type":"file"},on:{"input":_vm.uploadFile}}),_vm._v(" "),_c('q-button',{attrs:{"loading":_vm.uploading,"variation":"secondary"},on:{"click":_vm.clickFileInput}},[_vm._v("Voeg bijlage toe")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }